import { CourierDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import dayjs from 'dayjs';
import type { CourierRegistrationProps } from '../../../../ui/components/pure/page-headers/details/courier-details/courier-details-page-header.component';

/**
 * Where and when the courier registered. Undefined for couriers created any other way, so the
 * header drops the section rather than showing it empty.
 */
export function makeCourierRegistration(
  registration: CourierDto['registration'],
  /** The hub off registration.hubID and where it links to. Absent while loading or when it can't be read. */
  hub?: { name: string; url: string }
): CourierRegistrationProps | undefined {
  if (!registration) {
    return undefined;
  }

  return {
    hub: registration.hubID ? { name: hub?.name ?? 'Unknown hub', url: hub?.url } : undefined,
    // A kiosk sits at its hub, so it records a distance of zero; the courier app records how far away it was.
    isKiosk: registration.distanceInMetres === 0,
    distance: registration.distanceInMetres !== undefined ? formatDistance(registration.distanceInMetres) : undefined,
    time: registration.time ? dayjs(registration.time).format('DD MMM YYYY h:mma') : undefined
  };
}

/** Whole metres under a kilometre, kilometres to one decimal place from there. */
function formatDistance(distanceInMetres: number): string {
  const metres = Math.round(distanceInMetres);
  if (metres < 1000) {
    return `${metres.toLocaleString('en-AU')} m`;
  }
  return `${(metres / 1000).toLocaleString('en-AU', { maximumFractionDigits: 1 })} km`;
}
